import { Stack } from 'expo-router';
import ExternalAccountError from 'features/moveMoney/screens/transfer/TransferError/ExternalAccountError';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import theme from 'shared/styles/theme';

function ExternalAccountErrorPage() {
  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ExternalAccountError />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    padding: theme.spacing.m,
  },
});

export default ExternalAccountErrorPage;
